import { List, Create, Edit, View, Purchase } from "../Components/index.js";

export default [
    { path: "/voucher/store/recipe", component: List, name: "recipe.store.list" },
    { path: "/voucher/store/recipe/create", component: Create, name: "recipe.store.create" },
    { path: "/voucher/store/recipe/purchase/:id", component: Purchase, name: "recipe.store.purchase" },
    { path: "/voucher/store/recipe/:id/edit", component: Edit, name: "recipe.store.edit" },
    { path: "/voucher/store/recipe/:id/view", component: View, name: "recipe.store.view" }
];
